import { useState, useEffect } from "react";
import Header from "../../../components/organisms/Header";
import RenewalMotor from "../../../components/organisms/Renewal/motor";
import OtherDetailsRenewal from "../../../components/organisms/Motor-Insurance/Other-Details-Renewal";
import { StepperForm } from "../../../components/molecules/Stepper";
import { Cache } from "aws-amplify";
import { basePath, gcashAPI, motorAPI } from "../../../api/fetch-api";
import { formatNumber, formatDate } from "../../../components/utils/helper";
import Modal from "../../../components/molecules/Modal";
import { Loading } from "../../../components/atoms/loading";
import { useHistory } from "react-router-dom";
import ClientDetails from "../../../components/organisms/Common/ClientDetails";
import Summary from "../../../components/organisms/Motor-Insurance/Summary";
import dayjs from "dayjs";

const RenewalMotorIndex = (props) => {
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [detail, setDetail] = useState({});
  const [otherDetailsState, setOtherDetailsState] = useState([]);
  const [clientDetailsState, setClientDetailsState] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [nextState, setNextState] = useState(1);
  const [openRenewal, setOpenRenewal] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleNextState = (newFunction) => {
    setNextState(() => {
      return newFunction;
    });
  };
  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [loading]);

  useEffect(() => {
    if (otherDetailsState.length === 0) {
      setClientDetailsState(JSON.parse(Cache.getItem("clientInfo")));
      const clientInfo = JSON.parse(Cache.getItem("clientInfo"));
      const renewalData = Cache.getItem("renewalData");
      let isPrimaryDriver = "Y";
      if (renewalData?.drivers?.length <= 1) {
        if (
          (
            clientInfo.resultData?.firstName +
            " " +
            clientInfo.resultData?.middleName +
            " " +
            clientInfo.resultData?.lastName
          ).toLowerCase() != renewalData.drivers[0].name.toLowerCase()
        ) {
          isPrimaryDriver = "N";
        } else {
          isPrimaryDriver = "Y";
        }
      }
      const clientFullName = `${clientInfo.resultData?.firstName} ${clientInfo.resultData?.middleName} ${clientInfo.resultData?.lastName}`;
      const renewalFullName = `${renewalData.client.firstName} ${renewalData.client.middleName} ${renewalData.client.lastName}`;

      if (clientInfo && renewalData) {
        const isSameOwner = clientFullName === renewalData.assuredName;
        setOtherDetailsState({
          isOwner: "Y",
          ownerName: isSameOwner
            ? clientInfo.resultData?.firstName +
            " " +
            clientInfo.resultData?.middleName +
            " " +
            clientInfo.resultData?.lastName
            : renewalData.assuredName,
          isMortgage: "N",
          mortgagee: Cache.getItem("renewalData").mortgageeFlag,
          mortgageeFlag: renewalData.mortgageeFlag || "N",
          color: Cache.getItem("renewalData").color,
          chassisNumber: Cache.getItem("renewalData").chassisNumber,
          engineNumber: Cache.getItem("renewalData").engineNumber,
          contactNumber:
            Cache.getItem("renewalData").mortgageeDetail.contactNumber,
          contactPerson:
            Cache.getItem("renewalData").mortgageeDetail.contactPerson,
          emailAddress:
            Cache.getItem("renewalData").mortgageeDetail.emailAddress,
          officeAddress:
            Cache.getItem("renewalData").mortgageeDetail.officeAddress,
          driver: (renewalData.drivers != null && renewalData.drivers.length > 0) ? {
            ...renewalData.drivers[0],
            isPrimaryDriver: isPrimaryDriver,
          } : {
            isPrimaryDriver: "Y",
            driverName: clientInfo.firstName + " " + clientInfo.middleName + " " + clientInfo.lastName,
            birthday: clientInfo.birthday,
            driverGender: "",
            driverLicenseType: "",

          },
          isOwner: isSameOwner ? "Y" : "N",
        });
      }
    }
    const customerID = Cache.getItem("customerId")
      .replaceAll("+", " ")
      .replaceAll(" ", "%2B");
    const Dformat = (date1) => {
      var d = new Date(date1),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      var strArray = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      var m = strArray[d.getMonth()];
      return m + " " + day + ", " + year;
    };
    setDetail(Cache.getItem("renewalData"));
    setIsLoading(false);
  }, []);

  useEffect(() => { }, [clientDetailsState]);
  useEffect(() => { }, [otherDetailsState]);

  const handleNext = (e) => {
    e?.preventDefault();
    if (currentStep === pages.length - 1) {
      saveRenewal();
    } else {
      nextState();
      setCurrentStep((prevState) => {
        return (prevState = prevState + 1);
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    handleNext();
  };

  useEffect(() => {
    const renewalData = {
      ...Cache.getItem("renewalData"),
      otherDetails: {
        ...otherDetailsState,
      },
      drivers: otherDetailsState.drivers,
    };
    Cache.setItem(renewalData);
  }, [otherDetailsState]);

  const saveRenewal = () => {
    const checkData = {
      ...Cache.getItem("renewalData"),
      otherDetails: {
        ...otherDetailsState,
      },
      drivers: otherDetailsState.drivers,
    };

    console.log("CHECKDATA", checkData);
    if (
      checkData &&
      Array.isArray(checkData.otherDetails) &&
      checkData.otherDetails.length === 0
    ) {
    } else {
      if (checkData.otherDetails?.mortgageeFlag == "N") {
      } else {
        if (checkData.otherDetails.mortgageeFlag === "Y") {
          const {
            mortgagee,
            contactPerson,
            contactNumber,
            officeAddress,
            emailAddress,
          } = checkData.otherDetails;

          const missingFields = [
            !mortgagee && "Mortgagee",
            !contactPerson && "Contact Person",
            !contactNumber && "Contact Number",
            !officeAddress && "Office Address",
            !emailAddress && "Email Address",
          ].filter(Boolean);

          if (missingFields.length) {
            const errorMessage = `${missingFields.join(", ")} ${missingFields.length > 1 ? "are" : "is"
              } required.`;
            alert(errorMessage);
            setIsLoading(false);
            return;
          }
        }
      }

      setOpenRenewal(true);
    }
  };

  const handleSave = () => {
    setOpenRenewal(false);
    setDisabled(true);
    setIsLoading(true);

    const saveData = {
      ...Cache.getItem("renewalData"),
      otherDetails: otherDetailsState,
    };

    console.log("saveData", saveData);

    let mname = "";
    try {
      mname = clientDetailsState.resultData.middleName.charAt(0);
      if (mname != "-" && mname != "") {
        mname += ".";
      }
    } catch (err) {
      mname = "";
    }
    saveData.client.email = clientDetailsState.resultData.emailAddress;
    saveData.client.ginsureAccountId = saveData.insuranceAccountId;
    saveData.client.firstName = clientDetailsState.resultData.firstName;
    saveData.client.lastName = clientDetailsState.resultData.lastName;
    saveData.client.middleName = clientDetailsState.resultData.middleName;
    saveData.client.fullName =
      clientDetailsState.resultData.firstName +
      " " +
      clientDetailsState.resultData.middleName +
      " " +
      clientDetailsState.resultData.lastName;

    let oneYearInMillis = 365.25 * 24 * 60 * 60 * 1000;
    let newEndDate = saveData.startDate + oneYearInMillis;

    var middleNameState =
      String(otherDetailsState?.ownerMName).toLowerCase().trim() != "undefined"
        ? otherDetailsState.ownerMName + " "
        : "";
    var postData = {
      assuredName:
        otherDetailsState.isOwner === "Y"
          ? saveData.client.fullName
          : otherDetailsState.ownerName,
      bodyType: saveData.bodyType,
      bodySubtype: saveData.bodySubtype,
      chassisNumber: saveData.chassisNumber,
      client: saveData.client,
      color: saveData.color,
      endDate: new Date(newEndDate),
      engineNumber: saveData.engineNumber,
      engineType: saveData.engineType,
      fmv: saveData.fmv,
      make: saveData.make,
      model: saveData.model,
      modelid: saveData.modelid,
      mvFileNumber: null,
      plateNumber: saveData.plateNumber,
      questionnaire: null,
      seats: saveData.seats,
      startDate: new Date(saveData.startDate),
      year: saveData.year,
      mortgagee: saveData.mortgagee,
      mortgageeDetail: null,
      merchantId: "" + process.env.REACT_APP_MOTOR_ID + "",
      drivers: otherDetailsState.drivers,
      powerSource: saveData.powerSource,
    };

    console.log('POST-DATA', postData)

    if (saveData.otherDetails.length === 0 && saveData.mortgageeFlag === "Y") {
      postData.mortgagee = saveData.mortgagee;
      postData.mortgageeDetail = {
        contactNumber: formatNumber(saveData.mortgageeDetail.contactNumber),
        contactPerson: saveData.mortgageeDetail.contactPerson,
        emailAddress: saveData.mortgageeDetail.emailAddress,
        officeAddress: saveData.mortgageeDetail.officeAddress,
      };
    } else if (
      saveData.otherDetails.length !== 0 &&
      saveData.otherDetails?.mortgageeFlag === "Y"
    ) {
      postData.mortgagee = saveData.otherDetails.mortgagee;
      postData.mortgageeDetail = {
        contactNumber: formatNumber(saveData.otherDetails.contactNumber),
        contactPerson: saveData.otherDetails.contactPerson,
        emailAddress: saveData.otherDetails.emailAddress,
        officeAddress: saveData.otherDetails.officeAddress,
      };
    } else {
      postData.mortgagee = "";
      postData.mortgageeDetail = null;
    }

    const token_id = Cache.getItem("ginsure_token");
    fetch(basePath.baseUrl + "/quotation/motor/" + saveData.refId, {
      method: "PUT",
      body: JSON.stringify(postData),
      headers: {
        "Content-Type": "application/json",
        Authorization: token_id,
      },
    })
      .then((res) => {
        if (res.status == 200) {
          try {
            gcashAPI.postOrder(saveData.refId).then((data1) => {
              if (data1.resultInfo?.resultCode === "SYSTEM_ERROR") {
                alert(data1.resultInfo?.resultMsg);
                return;
              }

              setTimeout(() => {
                window.location.href = data1.checkoutUrl;
              }, 1000);
            });
          } catch (e) {
            console.log("error", e);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        console.log("There was an error!");
        setIsLoading(false);
      });
  };

  const goBackManagePolicy = () => {
    history.goBack();
  };

  const pages = [
    <RenewalMotor
      quoteData={detail}
      handleNextState={(v) => handleNextState(v)}
    />,
    <OtherDetailsRenewal
      saveData={(data) => setOtherDetailsState(data)}
      otherDetails={otherDetailsState}
      isRenewal={true}
      handleNextState={(v) => handleNextState(v)}
      clientDetailsState={clientDetailsState}
    />,
    <ClientDetails
      saveData={(data) => {
        setClientDetailsState(data);
      }}
      clientDetails={clientDetailsState}
      handleNextState={(v) => handleNextState(v)}
    />,
    <Summary
      backtoStart={() => {
        setCurrentStep(0);
      }}
      plateNumber={{ plateNumber: detail.plateNumber }}
      carDetails={{
        year: detail.year,
        make: detail.make,
        model: detail.model,
        modelid: detail.modelid,
        engineType: detail.engineType,
        fmv: detail.fmv,
        bodyType: detail.bodyType,
        subBodyType: detail.bodySubtype,
        seats: detail.seats,
        carDisplay: null,
        startDate: dayjs(detail.startDate).format("MMMM D, YYYY"),
        endDate: dayjs(detail.endDate).format("MMMM D, YYYY"),
      }}

      carDisplay={detail.model}
      otherDetails={{
        ...otherDetailsState,
        chassisNumber: detail.chassisNumber,
        engineNumber: detail.engineNumber,
      }}
      clientDetails={clientDetailsState}
      isRenewal={true}
    />,
  ];

  const backStep = () => {
    if (currentStep === 0) {
      history.goBack();
    } else {
      setCurrentStep((prevState) => {
        return (prevState = prevState - 1);
      });
    }
  };
  const headerTitle = [
    "Renewal Quotation",
    "Other Details",
    "Client Details",
    "Summary",
  ];

  return (
    <>
      <div>
        <Header headerTitle={headerTitle[currentStep]} saveData={backStep} />
        <div className="p-5 pt-12">
          <img src="/images/sici-logo.png" width="170" height="50" alt="logo" />
        </div>
        <main>
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="p-5">
                <ol className="flex w-full">
                  {pages.map((page, index) => (
                    <li key={index} className={`flex items-start`}>
                      {index < pages.length && (
                        <div
                          className={`w-16 h-3 mx-1 rounded-md ${index <= currentStep ? "bg-blue-600" : "bg-gray-400"
                            }`}
                        ></div>
                      )}
                    </li>
                  ))}
                </ol>
              </div>

              <form onSubmit={onSubmit} className="text-center">
                <div className="p-5">{pages[currentStep]}</div>
                <div className="fixed bottom-0 bg-white justify-center text-center mt-10 w-full">
                  <div className="footer-shadow py-5">
                    {!loading && (<>
                      <button
                        type={"submit"}
                        disabled={loading}
                        className="bg-blue-600 text-white py-3 w-10/12 mx-auto rounded-full manage-policy-font"
                      >
                        NEXT
                      </button>
                    </>)}

                  </div>
                </div>
              </form>

              <Modal
                open={openRenewal}
                setOpen={setOpenRenewal}
                title="Renewal Info"
                saveData={() => {
                  handleSave();
                }}
                buttonTitle={"Yes"}
                saveData2={() => {
                  setOpenConfirmation(true);
                  setOpenRenewal(false);
                }}
                buttonTitle2={"No"}
                isDisable={disabled}
              >
                <div>
                  <p>
                    Would you like to proceed with the renewal of your motorcar
                    comprehensive policy "{detail.policyNumber}"?
                  </p>
                </div>
              </Modal>

              <Modal
                open={openConfirmation}
                setOpen={setOpenConfirmation}
                title="Renewal Confirmation"
                saveData={() => {
                  goBackManagePolicy();
                }}
                buttonTitle={"Yes"}
                saveData2={() => {
                  setOpenConfirmation(false);
                  setOpenRenewal(false);
                }}
                buttonTitle2={"No"}
              >
                <div>
                  <p>
                    The inputted details will be lost if you do not proceed with
                    the payment of the policy renewal.
                  </p>
                </div>
              </Modal>
            </div>
          )}
        </main>
      </div>
    </>
  );
};

export default RenewalMotorIndex;
